import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'


const useExchangeStore = create((set, get) => ({
  exchanges_list: [],
  exchange_count: 0,
  add_exchange: async (infos) => {
    const res = await axios({
      method: "POST",
      url : '/api/make_exchange',
      data : infos,
      timeout : 2000
    })
  },
  fetchExchanges: async () => {
 
    const token = Cookies.get('token')
    const res = await axios({
      headers: { Authorization: token },
      method: "GET",
      url : '/api/fetch_exchanges',
      token : token,
      timeout : 10000
    })
    set({exchanges_list : await res.data})   
     
  },
  add_exchange: (exchange_infos) => {
    get().fetchExchanges()
  
    
  },
  remove_exchange: (exchange_infos) => {
    get().fetchExchanges()

  }
}))




export default useExchangeStore 